/**
 * External link icon
 *
 * @return {*} jsx
 */
export default function ExternalLinkIcon() {
	return (
		<svg
		xmlns="http://www.w3.org/2000/svg"
		width="13"
		height="16"
		viewBox="0 0 13 16"
		fill="none"
	>
		<path
			d="M11.0008 6.4L2.10078 15.3C1.91745 15.4833 1.68411 15.575 1.40078 15.575C1.11745 15.575 0.884115 15.4833 0.700781 15.3C0.517448 15.1167 0.425781 14.8833 0.425781 14.6C0.425781 14.3167 0.517448 14.0833 0.700781 13.9L9.60078 5H2.00078C1.71745 5 1.47995 4.90417 1.28828 4.7125C1.09661 4.52083 1.00078 4.28333 1.00078 4C1.00078 3.71667 1.09661 3.47917 1.28828 3.2875C1.47995 3.09583 1.71745 3 2.00078 3H12.0008C12.2841 3 12.5216 3.09583 12.7133 3.2875C12.9049 3.47917 13.0008 3.71667 13.0008 4V14C13.0008 14.2833 12.9049 14.5208 12.7133 14.7125C12.5216 14.9042 12.2841 15 12.0008 15C11.7174 15 11.4799 14.9042 11.2883 14.7125C11.0966 14.5208 11.0008 14.2833 11.0008 14V6.4Z"
			fill="currentColor"
		/>
	</svg>
	);
}
